module.exports = __webpack_public_path__ + "static/media/orange-heart.27c119c2.png";